import React from 'react';
import ReactTable from 'react-table';
import {Form, Segment} from 'semantic-ui-react';
import matchSorter from 'match-sorter';
import 'react-table/react-table.css';
import {ciklusi, cycles, faculties, fakulteti, grupacije, grupations, studijskiProgrami, studyPrograms} from './podaci';

const headerStyle = {
    whiteSpace: 'normal',
    wordWrap: 'break-word',
    textAlign: 'left',
    paddingTop: '10px',
    color: '#103362',
    fontWeight: 'bold',
};


const backgroundStyle = {
    backgroundImage: 'url(http://unsa.ba/s/images/stories/AZNUN/NOVI%20LOGO%20UNSA350.jpg)',
    backgroundColor: 'hsla(0,0%,100%,0.92)',
    backgroundBlendMode: 'overlay',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    backgroundSize: '500px 500px',
    backgroundPositionY: '60%'

};

const labelStyle = {
    textAlign: 'left',
    color: '#103362',
    fontWeight: 'bold',
    fontSize: '17px'
};

const logo = {
    height: '75px',
    width: '75px',
    paddingBottom: '15px'
};

const metaHeader = {
    backgroundColor: '#021932',
    height: '30px',
    margin: '0 auto',
    zIndex: '22',
    position: 'relative'
}

const languageMode = {
  color:'#ccc',
  float: 'right',
  paddingTop:'9px',
  paddingRight:'50px',
  textTransform: 'uppercase',
  fontFamily: 'Open Sans,sans-serif',
  fontSize: '0.87rem',
  cursor: 'pointer'
}

export default class Table extends React.Component {

    constructor() {
        super();
        this.state = {
            studijskiProgrami: [],
            studyPrograms: [],

            grupacija: '',
            fakultet: '',
            ciklus: '',

            grupation: '',
            faculty: '',
            ciclus: '',

            bosanski: true,
            engleski: false,
        };
        this.filterData = this.filterData.bind(this);
        this.filterDataEng = this.filterDataEng.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.imeFakulteta = this.imeFakulteta.bind(this);
        this.imeFakultetaEng = this.imeFakultetaEng.bind(this);
        this.imeGrupacije = this.imeGrupacije.bind(this);
        this.imeGrupacijeEng = this.imeGrupacijeEng.bind(this);
        this.imeCiklusa = this.imeCiklusa.bind(this);
        this.imeCiklusaEng = this.imeCiklusaEng.bind(this);
        this.listaFakulteta = this.listaFakulteta.bind(this);
        this.listaFakultetaEng = this.listaFakultetaEng.bind(this);
        this.listaGrupacija = this.listaGrupacija.bind(this);
    }

    componentDidMount() {
        fetch('https://rsp.unsa.ba/study-programs')
            .then(response => {
                if (!response.ok) {
                    throw new Error('Failed to fetch data!');
                }
                return response.json();
            })
            .then(data => {
                this.setState({ studijskiProgrami: data });
            })
            .catch(error => {
                console.error('Failed to fetch data!', error);
                this.setState({ studijskiProgrami: studijskiProgrami });
            });

        fetch('https://rsp.unsa.ba/study-programs-eng')
            .then(response => {
                if (!response.ok) {
                    throw new Error('Failed to fetch data!');
                }
                return response.json();
            })
            .then(data => {
                this.setState({ studyPrograms: data });
            })
            .catch(error => {
                console.error('Failed to fetch data!', error);
                this.setState({ studyPrograms: studyPrograms });
            });
    }

    listaFakulteta() {
        const { grupacija } = this.state;
        if (grupacija) {
            if (grupacija === '0') {
              this.setState({fakultet:'', ciklus:''})
                return fakulteti;
            } else if (grupacija === '1') {
                return fakulteti.filter(el => el.key === '0' || el.key === '1' || el.key === '2' || el.key === '21');
            } else if (grupacija === '2') {
                return fakulteti.filter(el => el.key === '0' || el.key === '5' || el.key === '9' || el.key === '11' || el.key === '12' || el.key === '14' || el.key === '24');
            } else if (grupacija === '3') {
                return fakulteti.filter(el => el.key === '0' || el.key === '7' || el.key === '15' || el.key === '20' || el.key === '26' || el.key === '28');
            } else if (grupacija === '4') {
                return fakulteti.filter(el => el.key === '0' || el.key === '23' || el.key === '25' || el.key === '27');
            } else if (grupacija === '5') {
                return fakulteti.filter(el => el.key === '0' || el.key === '3' || el.key === '6' || el.key === '13' || el.key === '17' || el.key === '19');
            } else if (grupacija === '6') {
                return fakulteti.filter(el => el.key === '0' || el.key === '8' || el.key === '16' || el.key === '18' || el.key === '22');
            } else if (grupacija === '7') {
                return fakulteti.filter(el => el.key === '0' || el.key === '4');
            }
        }
        return fakulteti;
    }

    listaFakultetaEng() {
        const { grupacija } = this.state;
        if (grupacija) {
            if (grupacija === '0') {
              this.setState({fakultet:'', ciklus:''})
                return faculties;
            } else if (grupacija === '1') {
                return faculties.filter(el => el.key === '0' || el.key === '1' || el.key === '2' || el.key === '21');
            } else if (grupacija === '2') {
                return faculties.filter(el => el.key === '0' || el.key === '5' || el.key === '9' || el.key === '11' || el.key === '12' || el.key === '14' || el.key === '24');
            } else if (grupacija === '3') {
                return faculties.filter(el => el.key === '0' || el.key === '7' || el.key === '15' || el.key === '20' || el.key === '26' || el.key === '28');
            } else if (grupacija === '4') {
                return faculties.filter(el => el.key === '0' || el.key === '23' || el.key === '25' || el.key === '27');
            } else if (grupacija === '5') {
                return faculties.filter(el => el.key === '0' || el.key === '3' || el.key === '6' || el.key === '13' || el.key === '17' || el.key === '19');
            } else if (grupacija === '6') {
                return faculties.filter(el => el.key === '0' || el.key === '8' || el.key === '16' || el.key === '18' || el.key === '22');
            } else if (grupacija === '7') {
                return faculties.filter(el => el.key === '0' || el.key === '4');
            }
        }
        return faculties;
    }

    listaGrupacija(fakultet) {

          if (fakultet === '1' || fakultet === '2' || fakultet === '21') {
                this.setState({grupacija: '1'});

            } else if ( fakultet === '5' || fakultet === '9' || fakultet === '11' || fakultet === '12' || fakultet === '14' || fakultet === '24') {
              this.setState({grupacija: '2'});

            } else if ( fakultet === '7' || fakultet === '15' || fakultet === '20' || fakultet === '26' || fakultet === '28') {
              this.setState({grupacija: '3'});

            } else if ( fakultet === '23' || fakultet === '25' || fakultet === '27') {
              this.setState({grupacija: '4'});

            } else if ( fakultet === '3' || fakultet === '6' || fakultet === '13' || fakultet === '17' || fakultet === '19') {
              this.setState({grupacija: '5'});

            } else if ( fakultet === '8' || fakultet === '16' || fakultet === '18' || fakultet === '22') {
              this.setState({grupacija: '6'});

            } else if ( fakultet === '4') {
              this.setState({grupacija: '7'});
            }

    }


    imeFakulteta(id) {
        const selected = fakulteti.find(el => el.key === id);
        if (selected && selected.text) return selected.text;
        return '';
    }

    imeGrupacije(id) {
        const selected = grupacije.find(el => el.key === id);
        if (selected && selected.name) return selected.name;
        return '';
    }

    imeCiklusa(id) {
        const selected = ciklusi.find(el => el.key === id);
        if (selected && selected.name) return selected.name;
        return '';
    }

    imeFakultetaEng(id) {
        const selected = faculties.find(el => el.key === id);
        if (selected && selected.text) return selected.text;
        return '';
    }

    imeGrupacijeEng(id) {
        const selected = grupations.find(el => el.key === id);
        if (selected && selected.name) return selected.name;
        return '';
    }

    imeCiklusaEng(id) {
        const selected = cycles.find(el => el.key === id);
        if (selected && selected.name) return selected.name;
        return '';
    }

    filterData() {
        const { grupacija, fakultet, ciklus } = this.state;
        if (ciklus === '0') { this.setState({ ciklus: '' }); }
        if (fakultet === '0') { this.setState({ fakultet: '' }); }
        if (grupacija === '0') { this.setState({ grupacija: '' }); }

        if (!grupacija && !fakultet && !ciklus) {
            return this.state.studijskiProgrami;
        } else if (grupacija && !fakultet && !ciklus) {
            return this.state.studijskiProgrami.filter(el => el.GrupacijaNaukaUmjetnosti === this.imeGrupacije(grupacija));
        } else if (grupacija && fakultet && !ciklus) {
            return this.state.studijskiProgrami.filter(el => el.GrupacijaNaukaUmjetnosti === this.imeGrupacije(grupacija) && el.FakultetAkademija === this.imeFakulteta(fakultet));
        } else if (grupacija && fakultet && ciklus) {
            return this.state.studijskiProgrami.filter(el => el.GrupacijaNaukaUmjetnosti === this.imeGrupacije(grupacija) && el.FakultetAkademija === this.imeFakulteta(fakultet) && el.CiklusStudija === this.imeCiklusa(ciklus));
        } else if (grupacija && !fakultet && ciklus) {
            return this.state.studijskiProgrami.filter(el => el.GrupacijaNaukaUmjetnosti === this.imeGrupacije(grupacija) && el.CiklusStudija === this.imeCiklusa(ciklus));
        } else if (!grupacija && fakultet && ciklus) {
            return this.state.studijskiProgrami.filter(el => el.FakultetAkademija === this.imeFakulteta(fakultet) && el.CiklusStudija === this.imeCiklusa(ciklus));
        } else if (!grupacija && !fakultet && ciklus) {
            return this.state.studijskiProgrami.filter(el => el.CiklusStudija === this.imeCiklusa(ciklus));
        } else if (!grupacija && fakultet && !ciklus) {
            return this.state.studijskiProgrami.filter(el => el.FakultetAkademija === this.imeFakulteta(fakultet));
        } return this.state.studijskiProgrami;
        return this.state.studijskiProgrami;
    }

    filterDataEng() {
        const { grupacija, fakultet, ciklus } = this.state;
        if (ciklus === '0') { this.setState({ ciklus: '' }); }
        if (fakultet === '0') { this.setState({ fakultet: '' }); }
        if (grupacija === '0') { this.setState({ grupacija: '' }); }

        if (!grupacija && !fakultet && !ciklus) {
            return this.state.studyPrograms;
        } else if (grupacija && !fakultet && !ciklus) {
            return this.state.studyPrograms.filter(el => el.GrupacijaNaukaUmjetnosti === this.imeGrupacijeEng(grupacija));
        } else if (grupacija && fakultet && !ciklus) {
            return this.state.studyPrograms.filter(el => el.GrupacijaNaukaUmjetnosti === this.imeGrupacijeEng(grupacija) && el.FakultetAkademija === this.imeFakultetaEng(fakultet));
        } else if (grupacija && fakultet && ciklus) {
            return this.state.studyPrograms.filter(el => el.GrupacijaNaukaUmjetnosti === this.imeGrupacijeEng(grupacija) && el.FakultetAkademija === this.imeFakultetaEng(fakultet) && el.CiklusStudija === this.imeCiklusa(ciklus));
        } else if (grupacija && !fakultet && ciklus) {
            return this.state.studyPrograms.filter(el => el.GrupacijaNaukaUmjetnosti === this.imeGrupacijeEng(grupacija) && el.CiklusStudija === this.imeCiklusaEng(ciklus));
        } else if (!grupacija && fakultet && ciklus) {
            return this.state.studyPrograms.filter(el => el.FakultetAkademija === this.imeFakultetaEng(fakultet) && el.CiklusStudija === this.imeCiklusaEng(ciklus));
        } else if (!grupacija && !fakultet && ciklus) {
            return this.state.studyPrograms.filter(el => el.CiklusStudija === this.imeCiklusaEng(ciklus));
        } else if (!grupacija && fakultet && !ciklus) {
            return this.state.studyPrograms.filter(el => el.FakultetAkademija === this.imeFakultetaEng(fakultet));
        } return this.state.studyPrograms;
        return this.state.studyPrograms;
    }


    handleInputChange(event, { name, value }) {
        this.setState({
            [name]: value
        });

        if(name=== 'grupacija') this.setState({fakultet:'0'})

        if(name === 'fakultet') this.listaGrupacija(value)

    }
    render() {
        const { fakultetiFilter, engleski, bosanski } = this.state;
        if(engleski){
        return (
          <div>
          <div style={metaHeader}>
          {/*<p style={languageMode}> <span onClick={()=>this.setState({engleski: true, bosanski: false})} >english</span>*/}
          {/*<span onClick={()=>this.setState({engleski: false, bosanski: true})}> / bosnian</span></p>*/}
          </div>

            <div style={{ fontFamily: 'Merriweather, serif', marginRight: '50px', marginLeft: '50px', marginBottom: '50px' }}>
                <div style={{ color: '#021932', fontSize: '1.5rem', lineHeight: '100px' }}>
                    <a style={{color: '#021932'}} href="http://www.unsa.ba"><img align="middle" style={logo} src="http://www.unsa.ba/themes/unsa/logo.svg"></img>&nbsp;
                        University of Sarajevo</a>
                    <span style={{ color: '#666666', float: 'right' }}>Register of study programs</span>
                </div>
                <hr/>
                <br />
                <Segment raised>
                    <Form>
                        <Form.Group widths="equal">
                            <Form.Field>
                                <label style={labelStyle}> Grupation</label>
                                <Form.Dropdown
                                    placeholder="Select grupation"
                                    fluid
                                    search
                                    selection
                                    value={this.state.grupacija}
                                    onChange={this.handleInputChange}
                                    name="grupacija"
                                    options={grupations}
                                />
                            </Form.Field>
                            <Form.Field>
                                <label style={labelStyle}> Faculty / academic</label>
                                <Form.Dropdown
                                    placeholder="Select faculty / academic"
                                    fluid
                                    search
                                    selection
                                    value={this.state.fakultet}
                                    onChange={this.handleInputChange}
                                    name="fakultet"
                                    options={this.listaFakultetaEng()}
                                />
                            </Form.Field>
                            <Form.Field>
                                <label style={labelStyle}> Study cycle</label>
                                <Form.Dropdown
                                    placeholder="Select study cycle"
                                    fluid
                                    search
                                    selection
                                    value={this.state.ciklus}
                                    onChange={this.handleInputChange}
                                    name="ciklus"
                                    options={cycles}
                                />
                            </Form.Field>
                        </Form.Group>
                    </Form>
                </Segment>
                <Segment raised style={backgroundStyle}>

                    <ReactTable
                        style={{ opacity: '0.9', fontSize: '15px' }}
                        data={this.filterDataEng()}
                        filterable
                        defaultFilterMethod={(filter, row) =>
                            String(row[filter.id]) === filter.value}

                        columns={[
                            {
                                Header: <div style={headerStyle}>
                                    Grupations of sciences / arts
                                </div>,
                                columns: [

                                    {

                                        id: 'GrupacijaNaukaUmjetnosti',
                                        accessor: d => d.GrupacijaNaukaUmjetnosti,
                                        filterMethod: (filter, rows) =>
                                            matchSorter(rows, filter.value, { keys: ['GrupacijaNaukaUmjetnosti'] }),
                                        filterAll: true,
                                        style: {
                                            whiteSpace: 'normal',
                                            paddingTop: '10px',
                                            wordWrap: 'break-word',
                                        },
                                    }

                                ]

                            },
                            {
                                Header: <div style={headerStyle}>
                                    Faculty / academy
                                </div>,
                                columns: [
                                    {
                                        id: 'FakultetAkademija',
                                        accessor: d => d.FakultetAkademija,
                                        filterMethod: (filter, rows) =>
                                            matchSorter(rows, filter.value, { keys: ['FakultetAkademija'] }),
                                        filterAll: true,
                                        style: {
                                            whiteSpace: 'normal',
                                            paddingTop: '10px',
                                            wordWrap: 'break-word',
                                            color: '#103362'
                                        }
                                    }
                                ]
                            },
                            {
                                Header: <div style={headerStyle}>
                                    Study cycle
                                </div>,
                                columns: [
                                    {
                                        id: 'CiklusStudija',
                                        accessor: d => d.CiklusStudija,
                                        filterMethod: (filter, rows) =>
                                            matchSorter(rows, filter.value, { keys: ['CiklusStudija'] }),
                                        filterAll: true,
                                        style: {
                                            whiteSpace: 'normal',
                                            paddingTop: '10px',
                                            wordWrap: 'break-word'
                                        }
                                    }
                                ]
                            },
                            {
                                Header: <div style={headerStyle}>
                                    Study program name
                                </div>,
                                columns: [
                                    {
                                        id: 'NazivStudijskogPrograma',
                                        accessor: d => d.NazivStudijskogPrograma,
                                        filterMethod: (filter, rows) =>
                                            matchSorter(rows, filter.value, { keys: ['NazivStudijskogPrograma'] }),
                                        filterAll: true,
                                        style: {
                                            whiteSpace: 'normal',
                                            paddingTop: '10px',
                                            wordWrap: 'break-word'
                                        }
                                    }
                                ]
                            },
                            // {
                            //     Header: <div style={headerStyle}>
                            //         Teaching implementation method
                            //     </div>,
                            //     columns: [
                            //         {
                            //             id: 'NacinRealizacijeNastave',
                            //             accessor: d => d.NacinRealizacijeNastave,
                            //             filterMethod: (filter, rows) =>
                            //                 matchSorter(rows, filter.value, { keys: ['NacinRealizacijeNastave'] }),
                            //             filterAll: true,
                            //             style: {
                            //                 whiteSpace: 'normal',
                            //                 paddingTop: '10px',
                            //                 wordWrap: 'break-word'
                            //             }
                            //         }
                            //     ]
                            // },
                            // {
                            //     Header: <div style={headerStyle}>
                            //         Qualification obtained and corresponding title
                            //     </div>,
                            //     columns: [
                            //         {
                            //             id: 'NazivKvalifikacijeIOdgovarajucaTitula',
                            //             accessor: d => d.NazivKvalifikacijeIOdgovarajucaTitula,
                            //             filterMethod: (filter, rows) =>
                            //                 matchSorter(rows, filter.value, { keys: ['NazivKvalifikacijeIOdgovarajucaTitula'] }),
                            //             filterAll: true,
                            //             style: {
                            //                 whiteSpace: 'normal',
                            //                 paddingTop: '10px',
                            //                 wordWrap: 'break-word'
                            //             }
                            //         }
                            //     ]
                            // },
                            // {
                            //     Header: <div style={headerStyle}>Jezik studija</div>,
                            //     columns: [
                            //         {
                            //             id: 'JezikStudija',
                            //             accessor: d => d.JezikStudija,
                            //             filterMethod: (filter, rows) =>
                            //                 matchSorter(rows, filter.value, { keys: ['JezikStudija'] }),
                            //             filterAll: true,
                            //             style: {
                            //                 whiteSpace: 'normal',
                            //                 paddingTop: '10px',
                            //                 wordWrap: 'break-word'
                            //             }
                            //         }
                            //     ]
                            // },
                            {
                                Header: <div style={headerStyle}>
                                    Study cycle duration (ECTS)
                                </div>,
                                columns: [
                                    {
                                        id: 'TrajanjeCiklusaStudijaECTS',
                                        accessor: d => d.TrajanjeCiklusaStudijaECTS,
                                        filterMethod: (filter, rows) =>
                                            matchSorter(rows, filter.value, { keys: ['TrajanjeCiklusaStudijaECTS'] }),
                                        filterAll: true,
                                        style: {
                                            whiteSpace: 'normal',
                                            paddingTop: '10px',
                                            wordWrap: 'break-word'
                                        }
                                    }
                                ]
                            },
                            // {
                            //     Header: <div style={headerStyle}>
                            //         Studies approval date
                            //     </div>,
                            //     columns: [
                            //         {
                            //             id: 'DatumSaglasnostiZaIzvodjenjeStudija',
                            //             accessor: d => d.DatumSaglasnostiZaIzvodjenjeStudija,
                            //             filterMethod: (filter, rows) =>
                            //                 matchSorter(rows, filter.value, { keys: ['DatumSaglasnostiZaIzvodjenjeStudija'] }),
                            //             filterAll: true,
                            //             style: {
                            //                 whiteSpace: 'normal',
                            //                 paddingTop: '10px',
                            //                 wordWrap: 'break-word'
                            //             }
                            //         }
                            //     ]
                            // },
                            {
                                Header: <div style={headerStyle}>
                                    Link to the study program
                                </div>,
                                columns: [
                                    {
                                        id: 'LinkNaStudijskiProgram',
                                        filterAll: false,
                                        accessor:  d => <a href={d.LinkNaStudijskiProgram} target="_blank"> LINK </a>,
                                        // accessor: 'LinkNaStudijskiProgram',
                                        style: {
                                            whiteSpace: 'normal',
                                            paddingTop: '10px',
                                            wordWrap: 'break-word'
                                        }
                                    },
                                ]
                            },

                        ]}
                        defaultPageSize={10}
                        className="-highlight"
                        previousText="Previous"
                        nextText="Next"
                        pageText="Page"
                        noDataText="No result"
                        ofText="of"
                        rowsText="rows"
                        minRows={5}


                    />
                </Segment>
                </div>
            </div>
        );}

          return (
            <div>
            <div style={metaHeader}>
            {/*<p style={languageMode}> <span onClick={()=>this.setState({engleski: true, bosanski: false})} >english</span>*/}
            {/*<span onClick={()=>this.setState({engleski: false, bosanski: true})}> / bosnian</span></p>*/}
            </div>

              <div style={{ fontFamily: 'Merriweather, serif', marginRight: '50px', marginLeft: '50px', marginBottom: '50px' }}>
                  <div style={{ color: '#021932', fontSize: '1.5rem', lineHeight: '100px' }}>
                      <a style={{color: '#021932'}} href="http://www.unsa.ba"><img align="middle" style={logo} src="http://www.unsa.ba/themes/unsa/logo.svg"></img>&nbsp;
                          Univerzitet u Sarajevu</a>
                      <span style={{ color: '#666666', float: 'right' }}>Registar studijskih programa</span>
                  </div>
                  <hr/>
                  <br />
                  <Segment raised>
                      <Form>
                          <Form.Group widths="equal">
                              <Form.Field>
                                  <label style={labelStyle}> Grupacija</label>
                                  <Form.Dropdown
                                      placeholder="Odaberite grupaciju"
                                      fluid
                                      search
                                      selection
                                      value={this.state.grupacija}
                                      onChange={this.handleInputChange}
                                      name="grupacija"
                                      options={grupacije}
                                  />
                              </Form.Field>
                              <Form.Field>
                                  <label style={labelStyle}> Fakultet / akademija</label>
                                  <Form.Dropdown
                                      placeholder="Odaberite fakultet / akademiju"
                                      fluid
                                      search
                                      selection
                                      value={this.state.fakultet}
                                      onChange={this.handleInputChange}
                                      name="fakultet"
                                      options={this.listaFakulteta()}
                                  />
                              </Form.Field>
                              <Form.Field>
                                  <label style={labelStyle}> Ciklus studija</label>
                                  <Form.Dropdown
                                      placeholder="Odaberite ciklus studija"
                                      fluid
                                      search
                                      selection
                                      value={this.state.ciklus}
                                      onChange={this.handleInputChange}
                                      name="ciklus"
                                      options={ciklusi}
                                  />
                              </Form.Field>
                          </Form.Group>
                      </Form>
                  </Segment>
                  <Segment raised style={backgroundStyle}>

                      <ReactTable
                          style={{ opacity: '0.9', fontSize: '15px' }}
                          data={this.filterData()}
                          filterable
                          defaultFilterMethod={(filter, row) =>
                              String(row[filter.id]) === filter.value}

                          columns={[
                              {
                                  Header: <div style={headerStyle}>
                                      Grupacija nauka / umjetnosti
                                  </div>,
                                  columns: [

                                      {

                                          id: 'GrupacijaNaukaUmjetnosti',
                                          accessor: d => d.GrupacijaNaukaUmjetnosti,
                                          filterMethod: (filter, rows) =>
                                              matchSorter(rows, filter.value, { keys: ['GrupacijaNaukaUmjetnosti'] }),
                                          filterAll: true,
                                          style: {
                                              whiteSpace: 'normal',
                                              paddingTop: '10px',
                                              wordWrap: 'break-word',
                                          },
                                      }

                                  ]

                              },
                              {
                                  Header: <div style={headerStyle}>
                                      Fakultet / akademija
                                  </div>,
                                  columns: [
                                      {
                                          id: 'FakultetAkademija',
                                          accessor: d => d.FakultetAkademija,
                                          filterMethod: (filter, rows) =>
                                              matchSorter(rows, filter.value, { keys: ['FakultetAkademija'] }),
                                          filterAll: true,
                                          style: {
                                              whiteSpace: 'normal',
                                              paddingTop: '10px',
                                              wordWrap: 'break-word',
                                              color: '#103362'
                                          }
                                      }
                                  ]
                              },
                              {
                                  Header: <div style={headerStyle}>
                                      Ciklus studija
                                  </div>,
                                  columns: [
                                      {
                                          id: 'CiklusStudija',
                                          accessor: d => d.CiklusStudija,
                                          filterMethod: (filter, rows) =>
                                              matchSorter(rows, filter.value, { keys: ['CiklusStudija'] }),
                                          filterAll: true,
                                          style: {
                                              whiteSpace: 'normal',
                                              paddingTop: '10px',
                                              wordWrap: 'break-word'
                                          }
                                      }
                                  ]
                              },
                              {
                                  Header: <div style={headerStyle}>
                                      Naziv studijskog programa
                                  </div>,
                                  columns: [
                                      {
                                          id: 'NazivStudijskogPrograma',
                                          accessor: d => d.NazivStudijskogPrograma,
                                          filterMethod: (filter, rows) =>
                                              matchSorter(rows, filter.value, { keys: ['NazivStudijskogPrograma'] }),
                                          filterAll: true,
                                          style: {
                                              whiteSpace: 'normal',
                                              paddingTop: '10px',
                                              wordWrap: 'break-word'
                                          }
                                      }
                                  ]
                              },
                              // {
                              //     Header: <div style={headerStyle}>
                              //         Način realizacije nastave
                              //     </div>,
                              //     columns: [
                              //         {
                              //             id: 'NacinRealizacijeNastave',
                              //             accessor: d => d.NacinRealizacijeNastave,
                              //             filterMethod: (filter, rows) =>
                              //                 matchSorter(rows, filter.value, { keys: ['NacinRealizacijeNastave'] }),
                              //             filterAll: true,
                              //             style: {
                              //                 whiteSpace: 'normal',
                              //                 paddingTop: '10px',
                              //                 wordWrap: 'break-word'
                              //             }
                              //         }
                              //     ]
                              // },
                              // {
                              //     Header: <div style={headerStyle}>
                              //         Naziv kvalifikacije i odgovarajuća titula
                              //     </div>,
                              //     columns: [
                              //         {
                              //             id: 'NazivKvalifikacijeIOdgovarajucaTitula',
                              //             accessor: d => d.NazivKvalifikacijeIOdgovarajucaTitula,
                              //             filterMethod: (filter, rows) =>
                              //                 matchSorter(rows, filter.value, { keys: ['NazivKvalifikacijeIOdgovarajucaTitula'] }),
                              //             filterAll: true,
                              //             style: {
                              //                 whiteSpace: 'normal',
                              //                 paddingTop: '10px',
                              //                 wordWrap: 'break-word'
                              //             }
                              //         }
                              //     ]
                              // },
                              // {
                              //     Header: <div style={headerStyle}>Jezik studija</div>,
                              //     columns: [
                              //         {
                              //             id: 'JezikStudija',
                              //             accessor: d => d.JezikStudija,
                              //             filterMethod: (filter, rows) =>
                              //                 matchSorter(rows, filter.value, { keys: ['JezikStudija'] }),
                              //             filterAll: true,
                              //             style: {
                              //                 whiteSpace: 'normal',
                              //                 paddingTop: '10px',
                              //                 wordWrap: 'break-word'
                              //             }
                              //         }
                              //     ]
                              // },
                              {
                                  Header: <div style={headerStyle}>
                                      Trajanje ciklusa studija (ECTS)
                                  </div>,
                                  columns: [
                                      {
                                          id: 'TrajanjeCiklusaStudijaECTS',
                                          accessor: d => d.TrajanjeCiklusaStudijaECTS,
                                          filterMethod: (filter, rows) =>
                                              matchSorter(rows, filter.value, { keys: ['TrajanjeCiklusaStudijaECTS'] }),
                                          filterAll: true,
                                          style: {
                                              whiteSpace: 'normal',
                                              paddingTop: '10px',
                                              wordWrap: 'break-word'
                                          }
                                      }
                                  ]
                              },
                              // {
                              //     Header: <div style={headerStyle}>
                              //         Datum saglasnosti za izvođenje studija
                              //     </div>,
                              //     columns: [
                              //         {
                              //             id: 'DatumSaglasnostiZaIzvodjenjeStudija',
                              //             accessor: d => d.DatumSaglasnostiZaIzvodjenjeStudija,
                              //             filterMethod: (filter, rows) =>
                              //                 matchSorter(rows, filter.value, { keys: ['DatumSaglasnostiZaIzvodjenjeStudija'] }),
                              //             filterAll: true,
                              //             style: {
                              //                 whiteSpace: 'normal',
                              //                 paddingTop: '10px',
                              //                 wordWrap: 'break-word'
                              //             }
                              //         }
                              //     ]
                              // },
                              {
                                  Header: <div style={headerStyle}>
                                      Link na studijski program
                                  </div>,
                                  columns: [
                                      {
                                          id: 'LinkNaStudijskiProgram',
                                          filterAll: false,
                                          accessor:  d => <a href={d.LinkNaStudijskiProgram} target="_blank"> LINK </a>,
                                          style: {
                                              whiteSpace: 'normal',
                                              paddingTop: '10px',
                                              wordWrap: 'break-word'
                                          }
                                      },
                                  ]
                              },

                          ]}
                          defaultPageSize={10}
                          className="-highlight"
                          previousText="Prethodna"
                          nextText="Sljedeća"
                          pageText="Stranica"
                          noDataText="Nema pronađenih podataka"
                          ofText="od"
                          rowsText="redova"
                          minRows={5}


                      />
                  </Segment>
                  </div>
              </div>
            );

    }
}



// WEBPACK FOOTER //
// ./src/Table.js